module.exports = __webpack_public_path__ + "media/cp3.16931f1b.mp4";